module.exports = "https://r.nearpod.com/assets/media/image/admin_red_icon-0522ab37d75ea006391493574a453640.svg";